import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll to top on route change (fixes mobile/desktop landing at page bottom after SPA navigation).
 * Preserves hash anchors (e.g. /#contact) when the target exists.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (typeof window.history.scrollRestoration === "string") {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    const scrollWindowTop = () => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    if (hash) {
      const id = hash.replace(/^#/, "");
      const scrollToHash = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          scrollWindowTop();
        }
      };
      scrollToHash();
      const t = window.setTimeout(scrollToHash, 100);
      return () => window.clearTimeout(t);
    }

    scrollWindowTop();
    const t = window.setTimeout(scrollWindowTop, 0);
    return () => window.clearTimeout(t);
  }, [pathname, hash]);

  return null;
}
